import type { ReactiveVar } from "@apollo/client";
import { useReactiveVar } from "@apollo/client";

import { makeFSVar } from "@shared/reactiveVar/makeFSVar";

interface CatalogType {
  type: "None" | "DTP" | "Wholesale" | "Patient" | "InOfficeCheckout" | "UnAuth";
}

const INITIAL_STATE: CatalogType = { type: "None" };

const catalogTypeVar: ReactiveVar<CatalogType> = makeFSVar(INITIAL_STATE, "useCatalogTypeVar");

const resetCatalogTypeVar = (): void => {
  catalogTypeVar(INITIAL_STATE);
};

const setCatalogTypeVar = (catalog: CatalogType): void => {
  catalogTypeVar(catalog);
};

const useCatalogTypeVar = (): CatalogType => {
  return useReactiveVar(catalogTypeVar);
};

export { useCatalogTypeVar, setCatalogTypeVar, resetCatalogTypeVar, catalogTypeVar };
